export default __webpack_public_path__ + "static/media/83t.bfd611c4.jpg";